import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useAddTestValuationUpdate = () => {
  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<{ data: unknown }, Error, void>({
    mutationFn: () => api.post('admin/test-unprocessed-valuation-updates', {}),
  });

  const addTestValuationUpdate = async () => {
    await mutateAsync();
  };

  return {
    addTestValuationUpdate,
    isLoading,
    error,
  };
};
